const state = () => ({
  loginVisible: false
})

const mutations = {
  setLoginVisible (state, visible) {
    state.loginVisible = visible
  },
}

const actions = {
  openLoginDialog({ commit }) {
    commit('setLoginVisible', true)
  },
  closeLoginDialog({ commit }) {
    commit('setLoginVisible', false)
  }
}

const getters = {
  isLoginVisible: state => state.loginVisible
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
